import React, { useEffect, useState } from 'react';
import { ClientApiProps } from '../common';
import { Acma_amateurradioassessortypes, IRegistryAssessor, getApiClientWihoutAuth } from '../api';
import { Label, Select, Spinner } from 'acma-spa';
import InfiniteScroll from 'react-infinite-scroll-component';

export const AssessorRegistry: React.FC<ClientApiProps> = (props) => {
  const [states, setStates] = useState<string[]>([]);
  const [selectedState, setSelectedState] = useState<string | null>(null);

  const [suburbs, setSuburbs] = useState<string[]>([]);
  const [selectedSuburb, setSelectedSuburb] = useState<string | null>(null);

  const [items, setItems] = useState<IRegistryAssessor[]>([]);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [hasMore, setHasMore] = useState(false);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const [client, abort] = getApiClientWihoutAuth(props.baseUrl);
    client.assessorRegistryGetStates().then((d) => setStates(d));
    return function () {
      abort.abort();
    };
  }, []);

  useEffect(() => {
    setPageNumber(1);

    if (!selectedState) {
      setSuburbs([]);
      return;
    }
    const [client, abort] = getApiClientWihoutAuth(props.baseUrl);
    client.assessorRegistryGetSuburbs(selectedState ?? undefined).then((d) => {
      setSuburbs(d);
    });
    return function () {
      abort.abort();
    };
  }, [selectedState]);

  useEffect(() => {
    setPageNumber(1);
  }, [selectedSuburb]);

  useEffect(() => {
    const [client, abort] = getApiClientWihoutAuth(props.baseUrl);

    if (pageNumber == 1) {
      setLoading(true);
      setItems([]);
      setHasMore(false);
    }

    client
      .assessorRegistryGet(selectedState ?? undefined, selectedSuburb ?? undefined, pageNumber)
      .then((d) => {
        setItems(pageNumber == 1 ? d : items.concat(d));
        setHasMore(d.length == 100);
      })
      .finally(() => setLoading(false));

    return function () {
      abort.abort();
    };
  }, [selectedState, selectedSuburb, pageNumber]);

  const onPaginate = () => {
    setPageNumber(pageNumber + 1);
  };

  return (
    <>
      <div className="row mb-3">
        <div className="col-lg-3 col-6">
          <Label label="States" id="states">
            <Select<string>
              options={states.map((r) => ({ label: r, value: r }))}
              value={selectedState}
              onChange={(v) => setSelectedState(v)}
              defaultLabel="Select..."
              size="block"
            />
          </Label>
        </div>
        {selectedState ? (
          <div className="col-lg-3 col-6">
            <Label label="Suburbs" id="suburbs">
              <Select<string>
                options={suburbs.map((r) => ({ label: r, value: r }))}
                value={selectedSuburb}
                onChange={(v) => setSelectedSuburb(v)}
                defaultLabel="Select..."
                size="block"
              />
            </Label>
          </div>
        ) : (
          <></>
        )}
      </div>

      <Spinner loadingText="Loading.." isLoading={isLoading}>
        <InfiniteScroll
          dataLength={items.length} //This is important field to render the next data
          next={onPaginate}
          hasMore={hasMore}
          loader={<h4>Loading...</h4>}
        >
          {items.map((r) => (
            <div className="card mb-2">
              <div className="card-header">
                <h4 className="my-0">
                  {r.fullName} {r.type == Acma_amateurradioassessortypes.Specialist ? <span className="badge badge-secondary">Specialist</span> : <></>}
                </h4>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-6">
                    {r.advertisedPhone}
                    {r.advertisedPhone && r.advertisedEmail ? <br /> : <></>}
                    {r.advertisedEmail ? <a href={`mailto:${r.advertisedEmail}`}>{r.advertisedEmail}</a> : <></>}
                  </div>
                  <div className="col-6">
                    {[r.advertisedAddress?.suburb, r.advertisedAddress?.state].filter((r) => r && r.length > 0).join(' ')}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </InfiniteScroll>
      </Spinner>
    </>
  );
};
